export default class CompetitorFeature {
  constructor(data, options = {}) {
    this.options_ = options;
    this.data = data;
  }

  getRecordId() {
    return this.data.properties.recordid;
  }

  getSIREN() {
    return this.data.properties.siren;
  }

  getSIRET() {
    return this.data.properties.siret;
  }

  getNIC() {
    return this.data.properties.nic;
  }

  getEnseigne() {
    return (
      this.data.properties?.denominationusuelleetablissement ?? this.data.properties?.enseigne1etablissement ?? this.data.properties?.denominationunitelegale ?? 'Non renseigné'
    );
  }

  getCodeNAF() {
    return this.data.properties.activiteprincipaleetablissement;
  }

  getClasseEtablissement() {
    return this.data.properties.classeetablissement;
  }

  getFormattedAddress() {
    return `${this.data.properties.adresse}, ${this.data.properties.codepostal} - ${this.data.properties.commune}`;
  }

  getFormattedDistance() {
    const dist = this.data.properties?.distance ?? null;
    return `${dist ? `${dist >= 1 ? `${dist.toFixed(2)} km` : `${(dist * 1000).toFixed(0)} m`}` : '--'}`;
  }

  getPopAddressContent() {
    return `
    <div>${this.data.properties.adresse}</div>
    <div>${this.data.properties.codepostal} - ${this.data.properties.commune} (${this.getFormattedDistance()})</div>`;
  }

  getPopupContent_old() {
    return `
    <div>
      <div class="slds-border_bottom">
        <div class="slds-text-heading_small">${this.getEnseigne()}</div>
        <div class="slds-m-around_xx-small slds-text-color_weak">${this.getFormattedAddress()}</div>
      </div>
      <div class="slds-region_narrow slds-m-top_small">
        <dl class="slds-dl_horizontal">
          <dt class="slds-dl_horizontal__label">SIREN:</dt>
          <dd class="slds-dl_horizontal__detail">${this.getSIREN()}</dd>
          <dt class="slds-dl_horizontal__label">NIC:</dt>
          <dd class="slds-dl_horizontal__detail">${this.getNIC()}</dd>
          <dt class="slds-dl_horizontal__label">SIRET:</dt>
          <dd class="slds-dl_horizontal__detail">${this.getSIRET()}</dd>
          <dt class="slds-dl_horizontal__label">NAF:</dt>
          <dd class="slds-dl_horizontal__detail">${this.getCodeNAF()}</dd>
          <dt class="slds-dl_horizontal__label">Classe établissement:</dt>
          <dd class="slds-dl_horizontal__detail">${this.getClasseEtablissement()}</dd>
        </dl>
      </div>
    </div>`;
  }
  getPopupContent_notbad() {
    return `
    <div>
      <div class="slds-border_bottom">
        <div class="slds-text-heading_small">${this.getEnseigne()}</div>
        <div class="slds-m-around_xx-small slds-text-color_weak">${this.getFormattedAddress()}</div>
      </div>
      <div>
        <table class="slds-table slds-table_striped slds-table_fixed-layout">
          <tbody style="vertical-align:top;">
            <tr class="slds-hint-parent">
              <td class="competitor-tbl-category"><div class="slds-text-align_right">SIREN:</div></td>
              <td>${this.getSIREN()}</td>
            </tr>
            <tr class="slds-hint-parent">
              <td class="competitor-tbl-category"><div class="slds-text-align_right">NIC:</div></td>
              <td>${this.getNIC()}</td>
            </tr>
            <tr class="slds-hint-parent">
              <td class="competitor-tbl-category"><div class="slds-text-align_right">SIRET:</div></td>
              <td>${this.getSIRET()}</td>
            </tr>
            <tr class="slds-hint-parent">
              <td class="competitor-tbl-category"><div class="slds-text-align_right">Code NAF:</div></td>
              <td>${this.getCodeNAF()}</td>
            </tr>
            <tr class="slds-hint-parent">
              <td class="slds-cell-wrap competitor-tbl-category"><div class="slds-text-align_right">Classe établissement:</div></td>
              <td class="slds-cell-wrap">${this.getClasseEtablissement()}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>`;
  }

  getPopupContent() {
    return `
    <div>
      <div class="slds-border_bottom">
        <div class="slds-text-heading_small">${this.getEnseigne()}</div>
        <div class="slds-m-around_xx-small slds-text-color_weak">${this.getPopAddressContent()}</div>
      </div>
      <div class="slds-m-top_xx-small">
        <div class="competitor_siret">SIRET: ${this.getSIRET()}</div>
        <div class="competitor_class_etab">${this.getClasseEtablissement()} (${this.getCodeNAF()})</div>
      </div>      
    </div>`;
  }
}
